import account from './account';
import analytics from './analytics';
import blog from './blog';
import cart from './cart';
import collection from './collection';
import footer from './footer';
import gatedPages from './gatedPages';
import giftWithPurchase from './giftWithPurchase';
import mysteryItems from './mysteryItems';
import header from './header';
import markdownmodal from './markdownmodal';
import product from './product';
import search from './search';
import social from './social';

export default [
  account,
  analytics,
  blog,
  cart,
  collection,
  footer,
  gatedPages,
  giftWithPurchase,
  mysteryItems,
  header,
  markdownmodal,
  product,
  search,
  social,
];
